export const OTC_SOURCE_OF_FUNDS = [
  'employment_income',
  'business_revenue',
  'savings',
  'investments',
  'sale_of_assets',
  'inheritance',
] as const

export type OtcSourceOfFunds = (typeof OTC_SOURCE_OF_FUNDS)[number]

export const OTC_PURPOSE = [
  'investment',
  'business_operations',
  'personal_savings',
  'goods_and_services',
  'family_support',
] as const

export type OtcPurpose = (typeof OTC_PURPOSE)[number]

export const OTC_SOURCES = ['email', 'widget', 'api'] as const

export type OtcSource = (typeof OTC_SOURCES)[number]

export const OTC_SOURCE_OF_FUNDS_LABELS: Record<OtcSourceOfFunds, string> = {
  employment_income: 'Employment income',
  business_revenue: 'Business revenue',
  savings: 'Personal savings',
  investments: 'Investments',
  sale_of_assets: 'Sale of assets',
  inheritance: 'Inheritance or gift',
}

export const OTC_PURPOSE_LABELS: Record<OtcPurpose, string> = {
  investment: 'Investment',
  business_operations: 'Business operations',
  personal_savings: 'Personal savings',
  goods_and_services: 'Purchasing goods or services',
  family_support: 'Family support',
}

export const isOtcSourceOfFunds = (value: string): value is OtcSourceOfFunds =>
  (OTC_SOURCE_OF_FUNDS as readonly string[]).includes(value)

export const isOtcPurpose = (value: string): value is OtcPurpose =>
  (OTC_PURPOSE as readonly string[]).includes(value)

export const otcSourceOfFundsLabel = (value: string): string =>
  OTC_SOURCE_OF_FUNDS_LABELS[value as OtcSourceOfFunds] ?? value

export const otcPurposeLabel = (value: string): string =>
  OTC_PURPOSE_LABELS[value as OtcPurpose] ?? value
